<ckeditor
	id="classic-editor"
	name="classic-editor"
	[(ngModel)]="value"
	[editor]="Editor"
	[disabled]="disabled"
	[ngClass]="{ disabled }"
	(ngModelChange)="emitChange()"
>
</ckeditor>
